module.exports = __webpack_public_path__ + "img/1539292885.b28ee9ca.jpg";